import { render, staticRenderFns } from "./Sincronizacao.vue?vue&type=template&id=4aa50fa5"
import script from "./Sincronizacao.vue?vue&type=script&lang=js"
export * from "./Sincronizacao.vue?vue&type=script&lang=js"
import style0 from "./Sincronizacao.vue?vue&type=style&index=0&id=4aa50fa5&prod&lang=scss"
import style1 from "./Sincronizacao.vue?vue&type=style&index=1&id=4aa50fa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports